import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import CloseIcon from '@mui/icons-material/Close';

import { removeNoteOnReferral } from '../store/slices/notesSlice';
import { clearTaskAccomplishmentInfo } from '../store/slices/dashboardStatsSlice';
import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { createStdRequest, apiFetch, dateStringForDateTime, showAlert } from '../utils/utils';

import DA from '../store/ReduxAccess';

import NewNoteModal from './NewNoteModal';
import ConfirmModal from './ConfirmModal';
import AlertModal from './AlertModal';

import noteAssocGroupStyles from '../assets/jss/crm/components/noteAssocGroupStyles';

/*
Call this with something like
  <NoteSummary
    key={note.noteId}
    note={note}
    pageRerenderFunc={function to rerender page in case we delete this note}
  />
*/

class NoteSummary extends React.Component {
  state = {
    shouldShowNoteModal: false,
    redirect: undefined,
  };

  showNoteModal() {
    this.setState({ shouldShowNoteModal: true });
  }

  offerToRemoveNote(note) {
    const q = 'Are you sure you want to delete this note?';
    this.setState({
      shouldShowDeletionConfirmationModal: true,
      deletionConfirmationQuery: q,
      deleteFunc: () => this.deleteNote(note),
    });
  }

  updateNote(text) {
    showAlert(this, 'should now update the note');
  }

  deleteNote(note) {
    const uri = `/api/note/${note.noteId}`;
    const request = createStdRequest(uri, 'DELETE');
    const actionOnGoodResponse = (json) => {
      this.props.clearTaskAccomplishmentInfo();
      this.props.removeNoteOnReferral(note.noteId);
      this.props.pageRerenderFunc();
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes, note } = this.props;
    const author = DA.getPersonById(note.authorId);
    const authorName = author ? author.preferredFullName : 'Unknown';
    return (
      <div>
        <AlertModal show={this.state.shouldShowAlertModal} renderer={this} text={this.state.alertModalText} />

        <ConfirmModal
          show={this.state.shouldShowDeletionConfirmationModal}
          title="Confirm Deletion"
          confirmButtonLabel="Delete"
          rejectButtonLabel="Cancel"
          onConfirm={this.state.deleteFunc}
          onReject={() => this.setState({ shouldShowDeletionConfirmationModal: false })}
        >
          <div>{this.state.deletionConfirmationQuery}</div>
        </ConfirmModal>

        <NewNoteModal
          show={this.state.shouldShowNoteModal}
          noteId={note.noteId}
          noteCreationFunc={(text) => this.updateNote(text)}
          noteDeletionFunc={() => this.deleteNote(note)}
          closeModalFunc={() => this.setState({ shouldShowNoteModal: false })}
        />
        <div className={cx(classes.entitySummary, classes.entitySummary_contact)}>
          <div className={classes.entitySummary_buttonContainer}>
            <Tooltip title="Delete" placement="top">
              <IconButton onClick={() => this.offerToRemoveNote(note)} size="large">
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
          <div className={cx(classes.entitySummary_detail, classes.ac_h5, classes.u_ellipsis)}>
            {dateStringForDateTime(note.date)}
          </div>
          <div className={cx(classes.entitySummary_subtitle, classes.u_ellipsis, classes.ac_h5)}>
            <span className={classes.entitySummary_subtitleName}>By:&nbsp;</span>
            <span className={classes.entitySummary_subtitleName}>{authorName}</span>
          </div>
          <div
            className={cx(classes.entitySummary_title, classes.u_ellipsis, classes.ac_h4)}
            onClick={() => this.showNoteModal()}
          >
            {note.content}
          </div>
        </div>
      </div>
    );
  }
}

const actionProducers = {
  removeNoteOnReferral,
  setApiResponseInfo,
  clearTaskAccomplishmentInfo,
};

export default connect(null, actionProducers)(withStyles(noteAssocGroupStyles)(NoteSummary));
